interface Options {
  length: number;
  uppercase?: boolean;
  numbers?: boolean;
  symbols?: boolean;
  exclude?: string;
}

export function randomPassword(
  options: Options = { 
    length: 16, 
    numbers: true, 
    exclude: '10iol' 
  }
) {

  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = lowercase.toUpperCase();
  const numbers = '0123456789';
  const symbols = '~!@#$%^&*()_+:"?><,./-{}[]=`';

  let text = lowercase;

  if (options.uppercase) text += uppercase;
  if (options.numbers) text += numbers;
  if (options.symbols) text += symbols;

  if (options.exclude) {
    for (const letter of options.exclude) {
      text = text.replace(letter, '');
    }
  }

  let password = '';
  const random = crypto.getRandomValues(new Uint32Array(options.length));

  for (const n of random) {
    password += text[n % text.length];
  }

  return password;
}
